import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { UsermanagementService } from '../../../service/usermanagement/usermanagement.service';


@Component({
  selector: 'app-form',
  templateUrl: './form.page.html',
  styleUrls: ['./form.page.scss'],
})
export class FormPage implements OnInit {
  @Input() user: any;
  public userForm: FormGroup;
  public isEditMode: boolean = false;

  private superUserId = ''; // Should be set based on the logged-in super user's ID


  private isSubmitting: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private alertController: AlertController,
    private UsermanagementService: UsermanagementService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.isEditMode = !!this.user;
    this.userForm = this.formBuilder.group({
      id: [this.user?.id || ''],
      displayname: [this.user?.displayname || '', Validators.required],
      email: [this.user?.email || '', [Validators.required, Validators.email]],
      //access: this.formBuilder.group({ // Create a nested group for access
        documentarchive: [this.user?.access_documentarchive || false],
        weighinreceipts: [this.user?.access_weighinreceipts || false],
        seasonalinfo: [this.user?.access_seasonalinfo || false],
      //})
    });
  }


  async presentDeleteConfirm(){
    const alert = await this.alertController.create({
      header: 'Bekræft sletningen',
      message: 'Er du sikker på at du vil slette brugeren?',
      buttons: [
        {
          text: 'Annuller',
          role: 'cancel' 
        }, {
          text: 'Ja, slet brugeren',
          role: 'confirm',
          handler: () => {
            this.deleteSubUser();
          }
        }
      ]
    });

    await alert.present();
  }

  private deleteSubUser() {
    const subUserInfo = this.userForm.value;

   this.UsermanagementService.deleteSubUser(subUserInfo)
      .subscribe({
        next: () => {

          const returnValues = {
            action :"deleted",
            id: subUserInfo.id
          }
          this.modalCtrl.dismiss(returnValues);
          this.userForm.reset();
        },
        error: (error) => {
          this.showAlert("Der opstod en fejl", "Der opstod desværre en fejl ved sletningen af brugen. Prøv venligst igen.")
          this.modalCtrl.dismiss();
        }
      })
  }

  

  submitForm() {
    if (this.isSubmitting) { return; } // Prevent double submission

    

    if (this.userForm.valid) {
      this.isSubmitting = true;

      const subUserInfo = this.userForm.value;

      const payload = {
        id: subUserInfo.id,
        displayname: subUserInfo.displayname,
        email: subUserInfo.email,
        access_documentarchive: subUserInfo.documentarchive,
        access_weighinreceipts: subUserInfo.weighinreceipts,
        access_seasonalinfo: subUserInfo.seasonalinfo,
      }

      if(!this.isEditMode){
        this.UsermanagementService.addSubUser(payload).subscribe({
          next: (result) => {
            this.isSubmitting = false; // Re-enable button
            console.log('RESULT', result)
            //this.subUsers.push(result); // Update the local list of sub-users
            this.userForm.reset(); // Reset the form after successful submission
            let msg = this.isEditMode ? 'Brugeren er hermed opdateret.' : 'Brugeren er hermed oprettet med brugernavnet:<br/><br/>' + result.username + '<br/><br/> Der er sendt en velkomstemail med adgangskode via email.';
            this.showAlert('Brugeren oprettet', msg);

            const payload = {
              id: result.id,
              displayname: result.displayname,
              email: result.email,
              access_documentarchive: result.access_documentarchive,
              access_weighinreceipts: result.access_weighinreceipts,
              access_seasonalinfo: result.access_seasonalinfo,
            }
            const returnValues = {
              action :"added",
              data: payload
            }
            this.modalCtrl.dismiss(returnValues);
          },
          error: (error) => {
            this.isSubmitting = false; // Re-enable button
            console.error('Error adding sub-user:', error);
            this.showAlert('Der opstod en fejl', 'Brugeren kunne ikke oprettes');
            this.modalCtrl.dismiss();
          }
        });
      }else{
        this.UsermanagementService.updateSubUser(payload).subscribe({
          next: (result) => {
            this.isSubmitting = false; // Re-enable button
            //this.UsermanagementService.getSubUsers();
            console.log('RESULT', result);
            
            let msg = this.isEditMode ? 'Brugeren er hermed opdateret og vil kunne se ændringerne ved næste login.' : 'Brugeren er hermed oprettet.';
            this.showAlert('Brugeren opdateret', msg);

            const payload = {
              id: subUserInfo.id,
              displayname: result.displayname,
              email: result.email,
              access_documentarchive: result.access_documentarchive,
              access_weighinreceipts: result.access_weighinreceipts,
              access_seasonalinfo: result.access_seasonalinfo,
            }
            const returnValues = {
              action :"updated",
              data: payload
            }
            this.modalCtrl.dismiss(returnValues);
            this.userForm.reset(); // Reset the form after successful submission
          },
          error: (error) => {
            this.isSubmitting = false; // Re-enable button
            console.error('Error adding sub-user:', error);
            this.showAlert('Der opstod en fejl', 'Brugeren kunne ikke opdateres');
            this.modalCtrl.dismiss();
          }
        })
      }
    }
  }

  async showAlert(header: string, message: string): Promise<void> {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK'],
    });

    await alert.present();
  }


  closeModal() {
    return this.modalCtrl.dismiss();
  }



}
